import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  brokers: null,
  broker: {
    name_en: '',
    name_ru: '',
    icon_primary: '',
    description_en: '',
    description_ru: '',
    description_fact_ru: '',
    description_fact_en: '',
    year: '',
    site: '',
    regulator: '',
    country_registration: '',
    min_deposit: '',
    currency: '',
    top_up_fee: '',
    top_out_fee: '',
    crypto_currency: '',
    investment: '',
    accounts: [],
    articles: [],
    pros_ru: '',
    pros_en: '',
    cons_ru: '',
    cons_en: '',
    report_ru: '',
    report_en: '',
  },
};

export const ratingSlice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    setRatingBrokers: (state, action) => {
      state.brokers = action.payload;
    },
    setRatingBroker: (state, action) => {
      state.broker = action.payload;
    },

    resetRating: () => initialState,
  },
});

export const {
  setRatingBrokers,
  setRatingBroker,

  resetRating,
} = ratingSlice.actions;

export default ratingSlice.reducer;
